import axios from "axios";
import authHeader from "./authHeader";

const GetAllInventoryList = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_EC2_CMS_ENDPOINT}api/MediaUpload/GetAllInventoryList`,
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeader(),
        },
      }
    );
    return res.data;
  } catch (error) {
    return error;
  }
};

const GetAllInventoryMaster = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_EC2_CMS_ENDPOINT}api/MediaUpload/GetAllInventoryMaster`,
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeader(),
        },
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

const UploadInventory = async (
  data: any,
  onUploadProgress: (progress: number) => void
) => {
  try {
    const formData = new FormData();
    formData.append("file", data.File, data.File.name);
    if (data.InventoryName) {
      formData.append("inventoryname", data.InventoryName);
    }
    if (data.Description) {
      formData.append("description", data.Description);
    }

    const response = await axios.post(
      `${process.env.REACT_APP_EC2_CMS_ENDPOINT}api/MediaUpload/UploadInventory`,
      formData,
      {
        headers: {
          ...authHeader(),
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onUploadProgress(percentCompleted);
          } else {
            onUploadProgress(100);
          }
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error uploading inventory file:", error);
    throw error;
  }
};

const InventoryService = {
  GetAllInventoryList,
  UploadInventory,
  GetAllInventoryMaster,
};

export default InventoryService;
